module.exports = __webpack_public_path__ + "static/media/newUser.ef6fb199.png";